import type { MailboxInfo } from 'owa-client-types';
import getCopilotPrioritizeSettings from './getCopilotPrioritizeSettings';

export default function getLastPrioritizeNudgeTimestamp(mailboxInfo: MailboxInfo): number | null {
    return getCopilotPrioritizeSettings(mailboxInfo).lastPrioritizeNudgeTimestampMs;
}
